import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  position: relative;

  .ant-table-container table > thead > tr:first-child th:last-child {
    border-top-right-radius: 0;
  }

  .ant-table-container table > thead > tr:first-child th:first-child {
    border-top-left-radius: 0;
  }

  .cover-default {
    image {
      width: 76.6px;
      height: 40px;
      @media screen and (max-width: 1042px) {
        width: 46.96px;
        height: 24px;
      }
    }

    svg {
      width: 76.6px;
      height: 40px;
      @media screen and (max-width: 768px) {
        width: 46.96px;
        height: 24px;
      }
    }
  }

  .ant-table table {
    border-collapse: collapse;
  }

  .ant-table-cell {
    padding: 8px 8px;
    border-bottom: 1px solid ${(props) => props.theme.colors.border};

    font-weight: 400;
    font-size: 12px;
    line-height: 16px;

    color: ${(props) => props.theme.colors.secondary};

    @media screen and (max-width: 768px) {
      padding: 8px 8px;
      font-size: 10px;
      line-height: 16px;
    }
    @media screen and (max-width: 500px) {
      padding: 8px 4px;
      font-size: 10px;
      line-height: 16px;
    }
  }

  .ant-table-cell::before {
    display: none;
  }

  .ant-table-placeholder {
    display: none;
  }

  .ant-table-tbody .ant-table-row {
    background-color: ${(props) => props.theme.colors.white} !important;
  }

  .ant-table-thead {
    border-bottom: none !important;

    .ant-table-cell {
      font-size: 10px;
      line-height: 14px;
      color: ${(props) => props.theme.colors.label};
      font-weight: 400;
      background-color: white;

      @media screen and (max-width: 768px) {
        font-size: 10px;
      }
    }
  }

  .ant-table-thead > tr > th {
    color: ${(props) => props.theme.colors.label};
    background: ${(props) => props.theme.colors.white} !important;
    border-collapse: separate;
  }

  .ant-table-column-sorter-up.active {
    color: ${(props) => props.theme.colors.blue};
  }

  .ant-table-column-sorter-down.active {
    color: ${(props) => props.theme.colors.blue};
  }

  .ant-skeleton.ant-skeleton-active .ant-skeleton-button {
    background: linear-gradient(
      60deg,
      rgba(239, 240, 246, 1) 25%,
      rgba(214, 216, 231, 1) 37%,
      rgba(239, 240, 246, 1) 63%
    );
    animation: blink 1s steps(1, end) infinite;
  }
`;
